module.exports = __webpack_public_path__ + "static/20260821_S&P_Rating_Report_B-_published-cfd0a89e9ea1da134d8ab4ae553a7753.pdf";